import { post } from "./http";
import common from './constants';
let basic = common.interfacePath.serverTestUrl;

export const groupBuy = {
  getResourceTypesList: (params) => {
    return post(`/teamBuyBuyer/getResourceTypesList`, params);
  }, 
  listWillStarTeamBuyPage: (params) => {
    return post(`/teamBuyBuyer/listWillStarTeamBuyPage`, params);
  }, 
  listInProgressTeamBuyPage: (params) => {
    return post(`/teamBuyBuyer/listInProgressTeamBuyPage`, params);
  },  
  listFinishedTeamBuyPage: (params) => {
    return post(`/teamBuyBuyer/listFinishedTeamBuyPage`, params);
  }, 
  listMyTradeTeamBuyPage: (params) => {
    return post(`/teamBuyBuyer/listMyTradeTeamBuyPage`, params);
  },
};

export const groupBuyDetails = {
  getCommodityById: (params) => {
    return post(`${basic}/product/getCommodityById`, params);
  },
  listTeamTradePage: (params) => {
    return post(`/teamBuyBuyer/listTeamTradePage`, params);
  }, 
  getTeamBuyBuyerById: (params) => {
    return post(`/teamBuyBuyer/getTeamBuyBuyerById`, params);
  },
}